import { useCallback } from "react";
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";

import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  nome: string;
  atribuicoes: string;
  escolaridade: string;
  status: number;
  onNomeChange: (nome: string) => void,
  onAtribuicoesChange: (nome: string) => void,
  onEscolaridadeChange: (nome: string) => void,
  onStatusChange: (status: number) => void,
  onClearFilters: () => void;
};

export const Header = ({
  nome,
  atribuicoes,
  escolaridade,
  status,
  onNomeChange,
  onAtribuicoesChange,
  onEscolaridadeChange,
  onStatusChange,
  onClearFilters,
}: Props) => {

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onStatusChange]);

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
            <div className="w-full">
              <DefaultInput
                label="Pesquisar por nome"
                name="search_by_nome"
                value={nome}
                onChangeValue={onNomeChange} />
            </div>

            <div className="w-full">
              <DefaultInput
                label="Pesquisar por atribuições"
                name="search_by_atribuicao"
                value={atribuicoes}
                onChangeValue={onAtribuicoesChange} />
            </div>

            <div className="w-full">
              <DefaultInput
                label="Pesquisar por escolaridade"
                name="search_by_escolaridade"
                value={escolaridade}
                onChangeValue={onEscolaridadeChange} />
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-1 gap-1">
              <FormControl size="small" fullWidth>
                <InputLabel id="modulo-dashboard"></InputLabel>
                <Select
                  labelId="modulo-dashboard"
                  label=""
                  value={status}
                  onChange={handleStatusChange}>
                  <MenuItem value={1}>Todos</MenuItem>
                  <MenuItem value={2}>Ativos</MenuItem>
                  <MenuItem value={3}>Inativos</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}